import React from "react";
import { Link } from "react-router-dom";

function PrivacyPolicy() {

  const scrollToSection = (event, sectionId) => {
    event.preventDefault();
  
    const element = document.getElementById(sectionId);
    const offset = 80;
  
    if (element) {
      const offsetPosition = element.offsetTop - offset;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }

  return (
    <section
      id="top"
      className="relative z-10 overflow-hidden py-16 md:py-[80px] xl:py-[100px]"
    >
      <div className="container">
        <h1 className="my-4 md:my-8 py-[40px] md:py-[120px] xl:py-[150px] text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-center text-black bg-slate-100/90 rounded">
          Privacy Policy
        </h1>
        <div className="-mx-4 pt-2 md:pt-4 flex flex-wrap">
          {/* Sidebar for Table of Contents */}
          <div className="hidden md:block md:w-1/4 lg:w-1/5 xl:w-1/6 pl-8 pr-4">
            <div className="sticky top-20">
              <h2 className="text-lg font-bold mb-4">Table of Contents</h2>
              <ul className="space-y-2 text-neutral-500">
                <li>
                  <a href="#1" className="hover:text-black" onClick={(e) => scrollToSection(e, '1')}>Purpose of the Privacy Policy</a>
                </li>
                <li>
                  <a href="#2" className="hover:text-black" onClick={(e) => scrollToSection(e, '2')}>Types of Information Collected</a>
                </li>
                <li>
                  <a href="#3" className="hover:text-black" onClick={(e) => scrollToSection(e, '3')}>How Information is Used</a>
                </li>
                <li>
                  <a href="#4" className="hover:text-black" onClick={(e) => scrollToSection(e, '4')}>Circumstances Under Which Information May Be Shared</a>
                </li>
                <li>
                  <a href="#5" className="hover:text-black" onClick={(e) => scrollToSection(e, '5')}>Third-Party Services and Partners</a>
                </li>
                <li>
                  <a href="#6" className="hover:text-black" onClick={(e) => scrollToSection(e, '6')}>Measures Taken to Protect User Data</a>
                </li>
                <li>
                  <a href="#7" className="hover:text-black" onClick={(e) => scrollToSection(e, '7')}>User Rights Regarding Their Data</a>
                </li>
                <li>
                  <a href="#8" className="hover:text-black" onClick={(e) => scrollToSection(e, '8')}>Statements Regarding the Use of XplorEase by Minors</a>
                </li>
                <li>
                  <a href="#9" className="hover:text-black" onClick={(e) => scrollToSection(e, '9')}>Procedures for Updating or Modifying the Privacy Policy</a>
                </li>
                <li>
                  <a href="#10" className="hover:text-black" onClick={(e) => scrollToSection(e, '10')}>Contact Details for Privacy-Related Inquiries</a>
                </li>
              </ul>
            </div>
          </div>

          {/* Main Content */}
          <div className="w-full md:w-3/4 lg:w-4/5 xl:w-5/6 px-4">
            <div
              className="wow fadeInUp mx-auto max-w-[800px]"
              data-wow-delay=".2s"
            >
              <h2
                id="1"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Purpose of the Privacy Policy
              </h2>
              <p className="mb-4 text-neutral-600">
                This Privacy Policy outlines our policies and procedures on the
                collection, use, and disclosure of your information when you use
                XplorEase. The policy is designed to help you understand how we
                handle your personal data and your rights in relation to that
                data.
              </p>

              <h2
                id="2"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Types of Information Collected
              </h2>
              <div className="mb-4 text-neutral-600">
                <p>
                  We collect various types of information for various purposes
                  to provide and improve our service to you. These include:
                </p>
                <ul className="mt-2 ml-8 list-disc">
                  <li>
                    <span className="font-semibold">Personal Data:</span>{" "}
                    Information that personally identifies you (e.g., name,
                    email address).
                  </li>
                  <li>
                    <span className="font-semibold">Non-Personal Data:</span>{" "}
                    Information that does not personally identify you but may
                    include usage and performance data.
                  </li>
                  <li>
                    <span className="font-semibold">Location Data:</span> We may
                    use and store information about your location if you permit
                    us to do so, to provide features of our service.
                  </li>
                </ul>
              </div>

              <h2
                id="3"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                How Information is Used
              </h2>
              <div className="mb-4 text-neutral-600">
                <p>We use the collected data for various purposes:</p>
                <ul className="mt-2 ml-8 list-disc">
                  <li>To provide and maintain our service.</li>
                  <li>To notify you about changes to our service.</li>
                  <li>
                    To allow you to participate in interactive features of our
                    service when you choose to do so.
                  </li>
                  <li>To provide customer support.</li>
                  <li>
                    To gather analysis or valuable information so that we can
                    improve our service.
                  </li>
                  <li>To monitor the usage of our service.</li>
                </ul>
              </div>

              <h2
                id="4"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Circumstances Under Which Information May Be Shared
              </h2>
              <div className="mb-4 text-neutral-600">
                <p>
                  We may share your personal information in the following
                  situations:
                </p>
                <ul className="mt-2 ml-8 list-disc">
                  <li>
                    <span className="font-semibold">
                      Non-Personal Data:Location Data:
                    </span>{" "}
                    With Service Providers: We may share your personal
                    information with service providers to monitor and analyze
                    the use of our service.
                  </li>
                  <li>
                    <span className="font-semibold">
                      For Business Transfers:
                    </span>{" "}
                    We may share or transfer your personal information in
                    connection with, or during negotiations of, any merger, sale
                    of company assets, financing, or acquisition of all or a
                    portion of our business to another company.
                  </li>
                  <li>
                    <span className="font-semibold">With Affiliates:</span> We
                    may share your information with our affiliates.
                  </li>
                </ul>
              </div>

              <h2
                id="5"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Third-Party Services and Partners
              </h2>
              <p className="mb-4 text-neutral-600">
                We may use third-party services and partners that may collect,
                monitor, and analyze this type of information in order to
                increase our service's functionality.
              </p>

              <h2
                id="6"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Measures Taken to Protect User Data
              </h2>
              <p className="mb-4 text-neutral-600">
                We value your trust in providing us your personal information,
                thus we are striving to use commercially acceptable means of
                protecting it. However, remember that no method of transmission
                over the internet, or method of electronic storage is 100%
                secure and reliable, and we cannot guarantee its absolute
                security.
              </p>

              <h2
                id="7"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                User Rights Regarding Their Data
              </h2>
              <p className="mb-4 text-neutral-600">
                You have the right to access, update, or delete the information
                we have on you. Whenever made possible, you can update your
                personal information directly within your account settings
                section.
              </p>

              <h2
                id="8"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Statements Regarding the Use of XplorEase by Minors
              </h2>
              <p className="mb-4 text-neutral-600">
                Our service does not address anyone under the age of 13. We do
                not knowingly collect personally identifiable information from
                anyone under the age of 13. If you are a parent or guardian and
                you are aware that your child has provided us with personal
                data, please contact us.
              </p>

              <h2
                id="9"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Procedures for Updating or Modifying the Privacy Policy
              </h2>
              <p className="mb-4 text-neutral-600">
                We may update our Privacy Policy from time to time. We will
                notify you of any changes by posting the new Privacy Policy on
                this page. We will let you know via email and/or a prominent
                notice on our Service, prior to the change becoming effective.
              </p>

              <h2
                id="10"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Contact Details for Privacy-Related Inquiries
              </h2>
              <p className="mb-4 text-neutral-600">
                If you have any questions or suggestions about our Privacy
                Policy, do not hesitate to{" "}
                <Link
                  to="/support"
                  className="text-primary underline hover:text-primary-dark"
                >
                  contact us
                </Link>{" "}
                at{" "}
                <a
                  href="mailto:info@demetrix.in"
                  className="text-primary underline hover:text-primary-dark"
                >
                  info@demetrix.in
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute top-5 right-0 z-[-1]">
        <svg
          width="238"
          height="531"
          viewBox="0 0 238 531"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            opacity="0.3"
            x="422.819"
            y="-70.8145"
            width="196"
            height="541.607"
            rx="2"
            transform="rotate(51.2997 422.819 -70.8145)"
            fill="url(#paint0_linear_83:2)"
          />
          <rect
            opacity="0.3"
            x="426.568"
            y="144.886"
            width="59.7544"
            height="541.607"
            rx="2"
            transform="rotate(51.2997 426.568 144.886)"
            fill="url(#paint1_linear_83:2)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_83:2"
              x1="517.152"
              y1="-251.373"
              x2="517.152"
              y2="459.865"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" />
              <stop offset="1" stopColor="#4A6CF7" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_83:2"
              x1="455.327"
              y1="-35.673"
              x2="455.327"
              y2="675.565"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" />
              <stop offset="1" stopColor="#4A6CF7" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="absolute left-0 bottom-5 z-[-1]">
        <svg
          width="279"
          height="106"
          viewBox="0 0 279 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.5">
            <path
              d="M-57 12L50.0728 74.8548C55.5501 79.0219 70.8513 85.7589 88.2373 79.3692C109.97 71.3821 116.861 60.9642 156.615 63.7423C178.778 65.291 195.31 69.2985 205.911 62.3533C216.513 55.408 224.994 47.7682 243.016 49.1572C255.835 50.1453 265.278 50.8936 278 45.3373"
              stroke="url(#paint0_linear_72:302)"
            />
            <path
              d="M-57 1L50.0728 63.8548C55.5501 68.0219 70.8513 74.7589 88.2373 68.3692C109.97 60.3821 116.861 49.9642 156.615 52.7423C178.778 54.291 195.31 58.2985 205.911 51.3533C216.513 44.408 224.994 36.7682 243.016 38.1572C255.835 39.1453 265.278 39.8936 278 34.3373"
              stroke="url(#paint1_linear_72:302)"
            />
            <path
              d="M-57 23L50.0728 85.8548C55.5501 90.0219 70.8513 96.7589 88.2373 90.3692C109.97 82.3821 116.861 71.9642 156.615 74.7423C178.778 76.291 195.31 80.2985 205.911 73.3533C216.513 66.408 224.994 58.7682 243.016 60.1572C255.835 61.1453 265.278 61.8936 278 56.3373"
              stroke="url(#paint2_linear_72:302)"
            />
            <path
              d="M-57 35L50.0728 97.8548C55.5501 102.022 70.8513 108.759 88.2373 102.369C109.97 94.3821 116.861 83.9642 156.615 86.7423C178.778 88.291 195.31 92.2985 205.911 85.3533C216.513 78.408 224.994 70.7682 243.016 72.1572C255.835 73.1453 265.278 73.8936 278 68.3373"
              stroke="url(#paint3_linear_72:302)"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_72:302"
              x1="256.267"
              y1="53.6717"
              x2="-40.8688"
              y2="8.15715"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" stopOpacity="0" />
              <stop offset="1" stopColor="#4A6CF7" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_72:302"
              x1="256.267"
              y1="42.6717"
              x2="-40.8688"
              y2="-2.84285"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" stopOpacity="0" />
              <stop offset="1" stopColor="#4A6CF7" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_72:302"
              x1="256.267"
              y1="64.6717"
              x2="-40.8688"
              y2="19.1572"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" stopOpacity="0" />
              <stop offset="1" stopColor="#4A6CF7" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_72:302"
              x1="256.267"
              y1="76.6717"
              x2="-40.8688"
              y2="31.1572"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" stopOpacity="0" />
              <stop offset="1" stopColor="#4A6CF7" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
